import { List } from "immutable";

import { CourseFromServerTag } from "seneca-common/features/course/state/models/state/courses/course/Course";
import Tag from "seneca-common/features/course/state/models/state/courses/course/tags/tag/Tag";

const premiumFreeTrialTagId = "1e0f81d3-ab06-4c21-b34e-5a4f7b1e7d55";

const UNSUPPORTED_TAG_IDS = [premiumFreeTrialTagId];

export function isUnsupportedCourseType({
  courseTypeTags
}: {
  courseTypeTags: CourseFromServerTag[] | Tag[] | List<Tag> | undefined;
}) {
  return !!courseTypeTags?.some(tag => {
    return UNSUPPORTED_TAG_IDS.includes(tag.id!);
  });
}
